import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=de90ed72&scoped=true"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de90ed72",
  null
  
)

export default component.exports